import React, { useState, useRef, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getLaws,
  setNewQuestionForm,
  setState,
  uploadQuizExcel,
  viewErrorLogs,
} from "./redux/lawCollegeSlice";
import Loader from "./loader/loader";
import * as XLSX from "xlsx";
import "./errorLogs.css";
import CommonTable from "./CommonTable";

// const ErrorLogsTable = () => {
//   const { errorLogs = {} } = useSelector((state) => state.lawCollegeQuiz);
//   const { errors = [], limit = 100 } = errorLogs;

//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(limit || 100);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [sortKey, setSortKey] = useState("None");
//   const dispatch = useDispatch();

//   // Fetch first page
//   useEffect(() => {
//     dispatch(viewErrorLogs({ requestBody: { limit: rowsPerPage, offset: 0 } }));
//   }, [dispatch, rowsPerPage]);

//   const filteredErrors = useMemo(() => {
//     return errors.filter(
//       (err) =>
//         err.question?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         String(err.id).includes(searchTerm)
//     );
//   }, [errors, searchTerm]);

//   const sortedErrors = useMemo(() => {
//     if (sortKey === "None") return filteredErrors;
//     return [...filteredErrors].sort((a, b) => {
//       if (a[sortKey] < b[sortKey]) return -1;
//       if (a[sortKey] > b[sortKey]) return 1;
//       return 0;
//     });
//   }, [filteredErrors, sortKey]);

//   const currentRows = sortedErrors;

//   const handlePageChange = (page) => {
//     const newPage = Math.max(1, page);
//     setCurrentPage(newPage);
//     dispatch(
//       viewErrorLogs({
//         requestBody: {
//           limit: rowsPerPage,
//           offset: (newPage - 1) * rowsPerPage,
//         },
//       })
//     );
//   };

//   return (
//     <div style={{}}>
//       <img
//         width="30"
//         height="30"
//         src="https://img.icons8.com/ios/50/delete-sign.png"
//         alt="delete-sign"
//         style={{ float: "right", cursor: "pointer" }}
//         onClick={() =>
//           dispatch(
//             setState({
//               key: "view_logs",
//               value: false,
//             })
//           )
//         }
//       />
//       <h4
//         className="text-3xl font-bold text-center mb-6 text-gray-800"
//         style={{}}
//       >
//         <strong>Upload Question Error Logs</strong>
//       </h4>

//       <div style={{ marginTop: "2%" }}>
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             flexWrap: "wrap", // allows responsiveness
//             gap: "20px",
//             marginBottom: "15px",
//           }}
//         >
//           {/* Pagination Controls */}
//           <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//             <strong>Pages:</strong>
//             <button
//               onClick={() => handlePageChange(currentPage - 1)}
//             >{`<`}</button>
//             <input
//               type="number"
//               className="form-control"
//               style={{ width: "70px" }}
//               value={currentPage}
//               min={1}
//               onChange={(e) => handlePageChange(Number(e.target.value))}
//             />
//             <button
//               onClick={() => handlePageChange(currentPage + 1)}
//             >{`>`}</button>
//           </div>

//           {/* Rows Per Page */}
//           <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
//             <strong>Rows per page:</strong>
//             <select
//               value={rowsPerPage}
//               onChange={(e) => {
//                 const newRows = Number(e.target.value);
//                 setRowsPerPage(newRows);
//                 setCurrentPage(1);
//                 dispatch(
//                   viewErrorLogs({
//                     requestBody: { limit: newRows, offset: 0 },
//                   })
//                 );
//               }}
//             >
//               {[10, 25, 50, 100].map((size) => (
//                 <option key={size} value={size}>
//                   {size}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Search Filter */}
//           <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
//             <strong>Search :</strong>
//             <input
//               type="text"
//               style={{
//                 borderRadius: "5px",
//                 border: "1px solid gray",
//                 padding: "3px 6px",
//               }}
//               placeholder="Search ..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//           </div>

//           {/* Sort Dropdown */}
//           <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
//             <strong>Sort by:</strong>
//             <select
//               value={sortKey}
//               onChange={(e) => setSortKey(e.target.value)}
//             >
//               <option>None</option>
//               <option value="id">id</option>
//               <option value="question">question</option>
//               <option value="correct_option">correct_option</option>
//             </select>
//           </div>
//         </div>
//       </div>

//       <table className="error-table">
//         <thead>
//           <tr>
//             <th>id</th>
//             <th>Level</th>
//             <th>File Name</th>
//             <th>question</th>
//             <th>Option A</th>
//             <th>Option B</th>
//             <th>Option C</th>
//             <th>Option D</th>
//             <th>Correct Option</th>
//             <th>Time stamp</th>
//             <th>Created_by</th>
//             <th>Error Message</th>
//           </tr>
//         </thead>
//         <tbody>
//           {currentRows.length > 0 ? (
//             currentRows.map((err) => (
//               <tr key={err.id}>
//                 <td>{err.id}</td>
//                 <td>{err.level}</td>
//                 <td>{err.filename}</td>
//                 <td>{err.question}</td>
//                 <td>{err.option_A || "NULL"}</td>
//                 <td>{err.option_B || "NULL"}</td>
//                 <td>{err.option_C || "NULL"}</td>
//                 <td>{err.option_D || "NULL"}</td>
//                 <td>{err.correct_option || "NULL"}</td>
//                 <td>
//                   {new Date(err.timestamp).toLocaleString("en-IN", {
//                     day: "2-digit",
//                     month: "short", // or "long"
//                     year: "numeric",
//                     hour: "2-digit",
//                     minute: "2-digit",
//                     hour12: true,
//                   }) || "NULL"}
//                 </td>
//                 <td>{err.created_by || "NULL"}</td>
//                 <td>{err.error_message || "NULL"}</td>
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td colSpan="12" style={{ textAlign: "center" }}>
//                 No rows found
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>
//     </div>
//   );
// };
const ErrorLogsTable = () => {
  const { errorLogs = {} } = useSelector((state) => state.lawCollegeQuiz);
  const { errors = [], limit = 100 } = errorLogs;

  const dispatch = useDispatch();

  // Fetch first page
  useEffect(() => {
    dispatch(
      viewErrorLogs({ requestBody: { limit: limit || 100, offset: 0 } })
    );
  }, [dispatch, limit]);
  const columns = [
    { key: "id", label: "ID" },
    { key: "law_name", label: "Law Name" },
    { key: "level", label: "Level" },
    { key: "filename", label: "File Name" },
    { key: "question", label: "Question" },
    { key: "option_A", label: "Option A" },
    { key: "option_B", label: "Option B" },
    { key: "option_C", label: "Option C" },
    { key: "option_D", label: "Option D" },
    { key: "correct_option", label: "Correct Option" },
    {
      key: "timestamp",
      label: "Time Stamp",
      render: (row) =>
        row.timestamp
          ? new Date(row.timestamp).toLocaleString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })
          : "NULL",
    },
    // { key: "created_by", label: "Created By" },
    { key: "error_message", label: "Error Message" },
  ];
  const tableData = errors.map((err) => ({
    ...err,
    option_A: err.option_A || "NULL",
    option_B: err.option_B || "NULL",
    option_C: err.option_C || "NULL",
    option_D: err.option_D || "NULL",
    correct_option: err.correct_option || "NULL",
    // created_by: err.created_by || "NULL",
    error_message: err.error_message || "NULL",
  }));

  return (
    <div style={{}}>
      <img
        width="30"
        height="30"
        src="https://img.icons8.com/ios/50/delete-sign.png"
        alt="delete-sign"
        style={{ float: "right", cursor: "pointer" }}
        onClick={() =>
          dispatch(
            setState({
              key: "view_logs",
              value: false,
            })
          )
        }
      />
      <h4
        className="text-3xl font-bold text-center mb-6 text-gray-800"
        style={{}}
      >
        <strong>Upload Question Error Logs</strong>
      </h4>

      <CommonTable
        total={errorLogs.total_count}
        filteredCount={errorLogs.filtered_count}
        columns={columns}
        data={tableData}
        initialRowsPerPage={100}
        searchableKeys={[
          "id",
          "question",
          "error_message",
          "level",
          "fileName",
          "question",
          "option_A",
          "option_B",
          "option_C",
          "option_D",
          "correct_option",
          "law_name",
        ]}
        fetchData={({ limit, offset }) =>
          dispatch(viewErrorLogs({ requestBody: { limit, offset } }))
        }
      />
    </div>
  );
};

export default function CollegeQuizQuestion() {
  const [excelFile, setExcelFile] = useState(null);
  const fileInputRef = useRef(null); // <-- ref for file input
  const { newQuestionForm, loading, view_logs, categories, selectedCategory } =
    useSelector((state) => state.lawCollegeQuiz);
  const userStr = localStorage.getItem("user");
  const userId = userStr
    ? JSON.parse(userStr).id
    : JSON.parse(userStr).user_id
    ? null
    : "";

  const dispatch = useDispatch();

  const handleLevelChange = (e) => {
    dispatch(
      setNewQuestionForm({ key: "difficulty_level", value: e.target.value })
    );
    dispatch(getLaws());
  };

  useEffect(() => {
    dispatch(getLaws());
    dispatch(
      setState({
        key: "selectedCategory",
        value: "",
      })
    );
  }, [dispatch]);
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setExcelFile(file);
  };

  const resetFileInput = () => {
    setExcelFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // clear file input
    }
  };

  // const handleUpload = async () => {
  //   if (!excelFile) return;
  //   dispatch(setState({ key: "loading", value: true }));
  //   try {
  //     const res = await dispatch(
  //       uploadQuizExcel({
  //         file: excelFile,
  //         difficultyLevel: newQuestionForm.difficulty_level,
  //       })
  //     ).unwrap();

  //     alert(
  //       `✅ ${res.message}\nInserted: ${res.inserted}\nSkipped: ${res.skipped}`
  //     );
  //     resetFileInput(); // reset file input
  //     dispatch(setNewQuestionForm({ key: "difficulty_level", value: "" }));
  //   } catch (err) {
  //     alert(`❌ Upload failed: ${err.message || "Unknown error"}`);
  //     resetFileInput();
  //     dispatch(setNewQuestionForm({ key: "difficulty_level", value: "" }));
  //   } finally {
  //     dispatch(setState({ key: "loading", value: false }));
  //   }
  // };

  const handleUpload = async () => {
    if (!excelFile) return;

    const fileData = await excelFile.arrayBuffer();
    const workbook = XLSX.read(fileData);
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

    // Read actual headers from first row (preserve case)
    const headers = jsonData[0]?.map((h) => h?.toString().trim()) || [];

    const requiredHeaders = [
      "question",
      "option_A",
      "option_B",
      "option_C",
      "option_D",
      "correct_option",
    ];

    const isValid =
      headers.length === requiredHeaders.length &&
      headers.every((header, index) => header === requiredHeaders[index]);

    if (!isValid) {
      alert(
        `❌ Upload failed:\nColumn names must be exactly:\n${requiredHeaders.join(
          ", "
        )}`
      );
      resetFileInput();
      dispatch(setNewQuestionForm({ key: "difficulty_level", value: "" }));
      return;
    }

    dispatch(setState({ key: "loading", value: true }));
    try {
      const res = await dispatch(
        uploadQuizExcel({
          created_by: userId,
          file: excelFile,
          difficultyLevel: newQuestionForm.difficulty_level,
          category: selectedCategory,
        })
      ).unwrap();

      alert(
        `✅ ${res.message}\nInserted: ${res.inserted}\nSkipped: ${res.skipped}`
      );
      resetFileInput();
      dispatch(setNewQuestionForm({ key: "difficulty_level", value: "" }));
      dispatch(
        setState({
          key: "selectedCategory",
          value: "",
        })
      );
    } catch (err) {
      alert(`❌ Upload failed: ${err.message || "Unknown error"}`);
      resetFileInput();
      dispatch(setNewQuestionForm({ key: "difficulty_level", value: "" }));
    } finally {
      dispatch(setState({ key: "loading", value: false }));
    }
  };

  return (
    <div className="container-fluid w-100 mx-auto py-2 font-inter">
      <div className="row mx-auto w-100">
        <div className="col-md-12 w-100">
          <h3 className="text-3xl font-bold text-center mb-6 text-gray-800">
            Law College Quiz Questions
          </h3>

          <div className="bg-white mb-8 max-w-4xl mx-auto shadow rounded-3 p-4">
            {/* Question Level Select */}
            <div className="row mb-3">
              <label className="col-sm-4 col-form-label font-medium text-gray-700">
                Select the Question's Difficulty Level{" "}
              </label>
              <div className="col-sm-8">
                <select
                  className="form-control"
                  value={newQuestionForm.difficulty_level}
                  onChange={handleLevelChange}
                  disabled={loading}
                >
                  <option value="">-- Select --</option>
                  <option value="basic">Basic Level</option>
                  <option value="advanced">Advanced Level</option>
                  <option value="ultra">Ultra Level</option>
                  <option value="docmaster">Docmaster</option>
                </select>
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-sm-4 col-form-label font-medium text-gray-700">
                Select Law
              </label>
              <div className="col-sm-8">
                <select
                  className="form-control"
                  value={selectedCategory}
                  onChange={(e) =>
                    dispatch(
                      setState({
                        key: "selectedCategory",
                        value: e.target.value,
                      })
                    )
                  }
                  disabled={loading}
                >
                  <option value="">-- Select --</option>
                  {categories
                    ?.slice() // make a shallow copy to avoid mutating original array
                    .sort((a, b) => a.name.localeCompare(b.name)) // alphabetical sort
                    .map((e) => (
                      <option key={e.id} value={e.id}>
                        {e.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            {/* Bulk Upload */}
            <div className="row mb-5">
              <div className="col-md-8">
                <input
                  ref={fileInputRef} // <-- attach ref
                  disabled={
                    !newQuestionForm.difficulty_level ||
                    loading ||
                    !selectedCategory
                  }
                  type="file"
                  accept=".xlsx, .xls"
                  className="form-control"
                  onChange={handleFileChange}
                />
              </div>
              <div className="col-md-4 text-end">
                <button
                  className={`btn btn-success w-100 ${
                    !excelFile ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                  disabled={!excelFile || loading}
                  onClick={handleUpload}
                >
                  Bulk Upload
                </button>
              </div>
              <br />
            </div>
            {loading && <Loader />}
          </div>
          <div
            style={{
              backgroundColor: "white",
              marginTop: "6%",
              borderRadius: "7px",
              padding: "15px",

              // height: "35vh",
              // overflow: "auto",
            }}
          >
            {!view_logs && (
              <div className="col-md-4 text-end">
                <button
                  className={`btn btn-success w-100 
          `}
                  style={{ marginTop: "5%" }}
                  onClick={() => {
                    dispatch(
                      setState({
                        key: "view_logs",
                        value: true,
                      })
                    );
                  }}
                >
                  View Upload Question Error Logs
                </button>
              </div>
            )}
            {view_logs && (
              <p>
                <ErrorLogsTable />
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
